import RendimientoProfesionalismo from '../domain/RendimientoProfesionalismo'
import RendimientoProfesionalismoDto from '../domain/RendimientoProfesionalismoDto'

class CreateRendimientoProfesionalismo {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacionDesempenioAcademico, idPersonal) {
    const catalogoReactivos = await this.#repository.getEvaluationItems()
    const dto = RendimientoProfesionalismoDto.create(evaluacionDesempenioAcademico, catalogoReactivos)
    const { data } = await this.#repository.create(dto, idPersonal)

    return data[0].ID
  }
}

export default CreateRendimientoProfesionalismo
